// 앱 다이나믹 링크
// (PC) 구글 플레이스토어 팬캐스트 이동
// (Mobile) 팬캐스트 앱 미설치 시, os에 따른 스토어 이동

// 홈
export const APP_FANCAST_HOME_URL = 'https://fancast.page.link/3NCj';

// 투표 메인
export const APP_FANCAST_VOTE_MAIN_URL = 'https://fancast.page.link/Yswj';
